<rid-button class="w-xs" [content]="content()" [disabled]="disabled()" [keybind]="keybind()" (click)="clicked.emit()" />
